export type CaptureClipboardGuardInput = {
  canSeeCsamTags: boolean;
  contentModerationType?: string | null;
  showObfuscatedPreview?: boolean;
  bypassCm?: boolean;
};

/**
 * Original (non-obfuscated) content-moderated media must never be copied to the
 * native OS clipboard from the capture workflow.
 */
export function shouldBlockCaptureClipboardForOriginalCsam(
  input: CaptureClipboardGuardInput,
): boolean {
  if (!input.canSeeCsamTags || !input.contentModerationType) {
    return false;
  }
  return input.bypassCm === true || input.showObfuscatedPreview === false;
}

/**
 * Re-encode a capture canvas as PNG and write it to the system clipboard.
 * WebP is not a valid ClipboardItem image type. Returns false when the
 * clipboard API is missing, the document is not focused, or the canvas is tainted.
 */
export async function copyCaptureCanvasToClipboard(
  canvas: HTMLCanvasElement,
): Promise<boolean> {
  if (typeof ClipboardItem === 'undefined' || !navigator.clipboard?.write) {
    return false;
  }
  try {
    const blob = await new Promise<Blob | null>((resolve) => {
      canvas.toBlob((value) => resolve(value), 'image/png');
    });
    if (!blob) return false;
    await navigator.clipboard.write([new ClipboardItem({ 'image/png': blob })]);
    return true;
  } catch {
    return false;
  }
}
